import { useMemo } from 'react';

import { EventBusyOutlined } from '@mui/icons-material';
import { ActionItemKeys, NotificationResponse } from '@uplift/api';
import { ROUTING_CONFIG, paymentsTabRoute } from '@uplift/constants';
import { trackToDoCTA, useActionItem, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';

export const useBetterhelpCoverageActionItem = () => {
  const l10n = useL10n();
  const coverageItem = useActionItem(ActionItemKeys.CLIENT_BETTERHELP_COVERAGE);

  const betterhelpCoverageActionItem = useMemo(() => {
    if (!coverageItem.show) {
      return null;
    }

    const copy = l10n.dashboard.actionItems.betterhelpCoverage;

    return (
      <LinkDashboardActionItem
        title={copy.title(coverageItem.sponsorName, coverageItem.sessionsRemaining)}
        details={coverageItem.hasInsurance ? copy.textWithInsurance : copy.textWithoutInsurance}
        color="warning"
        icon={<EventBusyOutlined />}
        link={coverageItem.hasInsurance ? paymentsTabRoute.createLink({ tab: 'coverage' }) : ROUTING_CONFIG.insurance}
        actionText={coverageItem.hasInsurance ? copy.actionText : copy.addInsuranceActionText}
        dismiss={coverageItem.hasInsurance ? { text: copy.dismissText, handleClick: () => coverageItem.dismiss(NotificationResponse.dismiss) } : undefined}
        onClick={() =>
          trackToDoCTA({
            toDoType: ActionItemKeys.CLIENT_BETTERHELP_COVERAGE,
            userType: UserRole.patient
          })
        }
      />
    );
  }, [ l10n.dashboard.actionItems.betterhelpCoverage, coverageItem ]);

  return {
    actionItem: betterhelpCoverageActionItem,
    isLoading: coverageItem.isLoading
  };
};
